<template>
  <div class="list-comment-cells">
    <div v-for="column in columns" :key="column.column_id" class="list-comment-cell-item">
      <listCommentCell
        :column="column"
        :content="cellContent(column)"
        :list_id="list_id"
        :sns_type="sns_type"
        :influencer_id="influencer_id"
        :index="index"
        @syncComment="onSyncComment"
      />
    </div>
  </div>
</template>

<script>
import listCommentCell from "./list_comment_cell.vue";

export default {
  name: "listCommentCells",
  components: { listCommentCell },
  props: {
    columns: { type: Array, default: () => [] },
    influencer: { type: Object, required: true },
    influencer_id: { type: String, required: true },
    list_id: { type: [String, Number], required: true },
    sns_type: { type: String, required: true },
    index: { type: Number, required: true },
  },
  methods: {
    cellContent(column) {
      const values = this.influencer.comment_values || {};
      return values[String(column.column_id)] ?? null;
    },
    onSyncComment(index, value, columnId) {
      if (!this.influencer.comment_values) {
        this.$set(this.influencer, "comment_values", {});
      }
      this.$set(this.influencer.comment_values, String(columnId), value);
      this.$emit("syncComment", index, value, "comment_column", columnId);
    },
  },
};
</script>

<style scoped>
.list-comment-cells {
  display: flex;
  flex-flow: row;
  align-items: stretch;
  width: max-content;
  min-width: 100%;
}
.list-comment-cell-item {
  min-width: 140px;
  width: 140px;
  max-width: 140px;
  flex-shrink: 0;
  padding: 0 4px;
  box-sizing: border-box;
}
</style>
